import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Page from '../shared/Page';
import { Plug } from '../shared/Plug/Plug';
import withRoleRestrictions from '../shared/withRoleRestrictions';
import withEulaRestrictions from '../license/withEulaRestrictions';
import { DYNAMIC_LAYOUT_ADMINS } from '../../constants/userRoles';
import { getBreadCrumbs } from '../../utils/breadCrumbs';
import { DASHBOARD, PAGE_PATHS, LAYOUT_MANAGEMENT } from '../../constants/pathsRoots';

import { LayoutManagementActions } from './LayoutManagementActions';
import LayoutManagementForm from './LayoutManagementForm';
import { LayoutManagementSelect } from './LayoutManagementSelect';
import { fetchLayouts, fetchLayoutById, save } from './utils';

class LayoutManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      layouts: null,
      loading: true,
      selectedLayout: null,
      selectedLayoutId: null,
      isValidForm: false,
      showErrors: false,
      copyLayout: false,
    };

    this.onSelectLayout = this.onSelectLayout.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.setFormValidStatus = this.setFormValidStatus.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  get header() {
    let title = 'Layout Management';

    if (this.props.addLayout) {
      title = this.state.copyLayout ? 'Copy Layout' : 'Add Layout';
    }

    return title;
  }

  get actions() {
    const { selectedLayout } = this.state;
    const { addLayout } = this.props;

    const onCancel = this.onCancel;
    const onSave = this.onSave;
    const props = { selectedLayout, addLayout, onCancel, onSave };

    return <LayoutManagementActions {...props} />;
  }

  get breadCrumbs() {
    const paths = [PAGE_PATHS[DASHBOARD]];

    if (this.props.addLayout) {
      paths.push(PAGE_PATHS[LAYOUT_MANAGEMENT]);
    }

    return getBreadCrumbs(this.header, '', paths);
  }

  get plug() {
    const { loading, selectedLayout } = this.state;
    const { addLayout } = this.props;

    return !loading ? (
      <Plug title="No layout found" />
    ) : (
      !selectedLayout && !addLayout && <Plug title="No layouts selected" />
    );
  }

  get options() {
    const { layouts } = this.state;

    return layouts && layouts.map((layout) => ({ label: layout.displayName, value: layout.id }));
  }

  componentDidMount() {
    const { match, addLayout } = this.props;
    const copyLayout = !!(match && match.params.id);

    this.setState({ copyLayout });

    const setLoading = (loading) => this.setState({ loading });

    if (!addLayout) {
      fetchLayouts(setLoading).then((layouts) => this.setState({ layouts }));
    }

    if (copyLayout) {
      fetchLayoutById(match.params.id, setLoading).then((layout) => this.setState({ selectedLayout: layout }));
    }
  }

  onSelectLayout(id) {
    this.setState({
      selectedLayoutId: id,
      selectedLayout: this.state.layouts.find((layout) => id === layout.id),
    });
  }

  onFieldChange(name, value) {
    this.setState((prevState) => ({
      selectedLayout: {
        ...prevState.selectedLayout,
        [name]: value,
      },
    }));
  }

  onCancel() {
    this.setState({ selectedLayout: null, selectedLayoutId: null });
    this.props.history.push('/layouts');
  }

  onSave() {
    const { selectedLayout, isValidForm } = this.state;
    const { addLayout: isNew } = this.props;

    this.setState({ showErrors: true });

    if (!isValidForm) {
      return;
    }

    save(selectedLayout, isNew)
      .then(() => this.afterSaving())
      .catch(() => {});
  }

  afterSaving() {
    const { addLayout, history } = this.props;

    if (addLayout) {
      history.push('/layouts/');
    } else {
      fetchLayouts((loading) => this.setState({ loading })).then((layouts) => {
        this.setState({ layouts });
      });
    }
  }

  setFormValidStatus(status) {
    this.setState({ isValidForm: status });
  }

  render() {
    const { layouts, selectedLayout, showErrors, errors } = this.state;
    const { addLayout } = this.props;

    return (
      <Page header={this.header} actions={this.actions} breadCrumbs={this.breadCrumbs}>
        {errors && Object.values(errors).map((error) => error)}
        {layouts && !addLayout && (
          <LayoutManagementSelect
            value={this.state.selectedLayoutId}
            options={this.options}
            onSelect={this.onSelectLayout}
          />
        )}
        {this.plug}
        {(selectedLayout || addLayout) && (
          <LayoutManagementForm
            {...selectedLayout}
            onFieldChange={this.onFieldChange}
            setFormValidStatus={this.setFormValidStatus}
            showErrors={showErrors}
          />
        )}
      </Page>
    );
  }
}

LayoutManagement.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  addLayout: PropTypes.bool,
};

const mapStateToProps = ({ profile }) => ({
  user: profile,
});

export default connect(mapStateToProps)(
  withEulaRestrictions(withRoleRestrictions(LayoutManagement, DYNAMIC_LAYOUT_ADMINS, false)),
);



// WEBPACK FOOTER //
// src/components/LayoutManagement/index.jsx